import { jsx as _jsx } from "react/jsx-runtime";
import { DropdownButton, Tooltip } from '@dixa/lib-shared-habla';
import { useRef, useState } from 'react';
import { CategorizedTagsList, } from 'components/categorizedTagsList';
import { CommandKeybindingsTooltipContent } from 'components/commandKeybindingsTooltipContent';
import { useCommandHandler } from 'utils/commands';
/** Represents a tags dropdown button. */
export const TagsDropdownButton = ({ tags, isLoading, onChange, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownButtonRef = useRef(null);
    useCommandHandler({
        name: 'conversation:tagsSelector',
        actionFn: () => {
            var _a;
            (_a = dropdownButtonRef.current) === null || _a === void 0 ? void 0 : _a.handleDropdownToggle();
        },
    });
    const tooltipContent = (_jsx(CommandKeybindingsTooltipContent, Object.assign({ commandName: "conversation:tagsSelector" }, { children: "Add conversation tag" })));
    return (_jsx(Tooltip, Object.assign({ dark: true, content: tooltipContent, wrap: "div" }, { children: _jsx(DropdownButton, Object.assign({ ref: dropdownButtonRef, icon: "tag", show: isOpen, isLoading: isLoading, buttonProps: { variant: 'tertiary' }, fixed: true, dropdown: _jsx(CategorizedTagsList, { isActive: isOpen, selectedTags: tags, onChange: onChange }), onToggle: setIsOpen }, { children: "Add tag" })) })));
};
